import { useBackendApi } from './backendApi';
import { ProjectType } from './Types';
import { useEventsPublisher } from 'event-bus';

export interface CreateContractTemplateRequest {
  projectType: ProjectType,

}

export const CONTRACT_TEMPLATE_UPDATED = 'CONTRACT_TEMPLATE_CREATED';

export function useContractTemplateAdminService() {

  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const createContractTemplate = async (
    setupAreaId: number,
    setupAreaVersion: string,
    request: CreateContractTemplateRequest,
  ) => {
    await backendApi.post(`/manager/setupareas/${setupAreaId}/${setupAreaVersion}/contracttemplate`, request);

    eventsPublisher.publish(CONTRACT_TEMPLATE_UPDATED, {});
  };

  const deleteContractTemplate = async (
    contractTemplateId: number,
  ) => {
    await backendApi.delete(`/manager/contracttemplates/${contractTemplateId}`);

    eventsPublisher.publish(CONTRACT_TEMPLATE_UPDATED, {});
  }

  return {
    createContractTemplate,
    deleteContractTemplate,
  };
}
